import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "产品系列",
    links: [
      { label: "香氛系列", path: "/category/fragrance" },
      { label: "肌肤养护", path: "/category/skincare" },
      { label: "限定礼盒", path: "/category/gift" },
    ],
  },
  {
    title: "品牌故事",
    links: [
      { label: "关于我们", path: "/about" },
      { label: "品牌理念", path: "/about#philosophy" },
      { label: "口碑评价", path: "/about#reputation" },
    ],
  },
  {
    title: "客户服务",
    links: [
      { label: "联系我们", path: "/about#contact" },
      { label: "常见问题", path: "/#faq" },
      { label: "配送说明", path: "/article/delivery" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 max-w-7xl mx-auto">
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-2xl font-semibold text-background-50 whitespace-nowrap cursor-pointer">
              媚肉之香
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-xs">
              融合东方香氛美学与肌肤养护精髓，探索香与肌肤之间最深层的共鸣，唤醒内在魅力与自信。
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-file-list-3-line text-base"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 媚肉之香 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">Cookie 设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}